import { Door1, Door2, Counter1, Counter2 } from "../../../../content/blog/react-state-management-with-usereducer/components";
import * as React from 'react';
export default {
  Door1,
  Door2,
  Counter1,
  Counter2,
  React
};